import React from 'react'
import PropTypes from "prop-types"
import {css} from '@emotion/react'
import {Container,Row} from 'reactstrap'
import { navigateTo, navigate } from 'gatsby'
import { Trans, Link} from 'gatsby-plugin-react-i18next'
import { oneSignalSendExternalUserId, oneSignalSendKeepWatching } from '../utils'

class History extends React.Component {
  static propTypes = {
    poster: PropTypes.string, 
    slug: PropTypes.string, 
    title: PropTypes.string, 
  }

  state = {
    history: []
  }

  // Fetch history from localstorage and put it in state
  async componentDidMount(){

    const {poster, slug, title} = this.props

    let history = await JSON.parse(localStorage.getItem('history'))

    if (!history) {
      history = []
    } else {
      history = history.slice(0,40)
    }

    this.setState({history})

    if(poster && slug && title) {
      const historyItem = {title, poster, slug}
      const newHistory = history.filter( (i) => i.slug !== slug )
      newHistory.unshift(historyItem)
      localStorage.setItem('history', JSON.stringify(newHistory))
      // oneSignalSendKeepWatching(title, slug, poster)
    }
    oneSignalSendExternalUserId()
  }

  render() {
    const {history} = this.state

    if (history.length < 1) return ''

    const row = history.map(h => (
        <div css={item}>
          <Link to={`/t/${h.slug}`}>
            <img loading="lazy" src={h.poster} alt={h.title} width="67" height="98"/>
          </Link>
        </div>
      )
    )

    return (
      <Container fluid >
        <h6 className="ml-2"><Trans>Vu récemment</Trans> </h6>
        <Row className="m-2 y-scroll">
          {row}
        </Row>
      </Container>
    )
  }
}

export default History


const title = css({
  
})

const item = css({
  backgroundColor: '#FFFFFF',
  border: '1px solid rgba(0,0,0,0.2)',
  display: 'inline-block',
  marginRight: 10,
  position: 'relative',
  boxShadow: '0 1px 6px rgba(0,0,0,0.2)',
  fontSize: '0',
  height: 98,
  width: 67,
})
